import React from 'react'

import { Form, Col } from '_zari/core'

import { Select2CuentaContable } from 'sharedComponents/select2'
import { ClearInputGroup } from 'sharedComponents/utils'

const CuentaContableDolaresFormGroup = ({ iValue, iError, iTouched, setFieldValue }) => {
  const onChange = React.useCallback(
    salida => {
      setFieldValue('cuentaContableDolares', salida.value)
      setFieldValue('cuentaContableDolaresInfo', salida.label)
    },
    [setFieldValue]
  )

  const clickClear = React.useCallback(() => {
    setFieldValue('cuentaContableDolares', '')
    setFieldValue('cuentaContableDolaresInfo', '')
  }, [setFieldValue])

  return (
    <Form.Group>
      <Form.Label
        text='CUENTA DOLARES'
        htmlFor='select-cuentaContableDolares'
        md={4}
        alignRightAt='md'
      />
      <Col md={8}>
        {iValue ? (
          <ClearInputGroup id='cuentaContableDolares' iValue={iValue} clickClear={clickClear} />
        ) : (
          <Select2CuentaContable id='select-cuentaContableDolares' onChange={onChange} />
        )}
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(CuentaContableDolaresFormGroup)
